import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex justify-between h-16" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex-shrink-0 flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-extrabold tracking-tight text-gray-400 ml-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700" }, "Supplier"),
  /*#__PURE__*/_createTextVNode(" Portal")
], -1)
const _hoisted_6 = { class: "hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8" }
const _hoisted_7 = ["onClick", "href", "aria-current"]
const _hoisted_8 = { class: "hidden sm:ml-6 sm:flex sm:items-center" }
const _hoisted_9 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "p-2 bg-gray-100 rounded-full"
}
const _hoisted_13 = { class: "-mr-2 flex items-center sm:hidden" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_15 = { class: "pt-2 pb-3 space-y-1" }
const _hoisted_16 = { class: "pt-4 pb-3 border-t border-gray-200" }
const _hoisted_17 = { class: "flex items-center px-4" }
const _hoisted_18 = { class: "flex-shrink-0" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "p-2 bg-gray-100 rounded-full"
}
const _hoisted_21 = { class: "ml-3" }
const _hoisted_22 = { class: "text-base font-medium text-gray-800" }
const _hoisted_23 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_24 = { class: "mt-3 space-y-1" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Change Vendor")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Logout")

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import {
  BellIcon,
  MenuIcon,
  XIcon,
  SelectorIcon,
} from "@heroicons/vue/outline";
import { UserIcon } from "@heroicons/vue/solid";
import VendorModal from "@/components/VendorModal.vue";
import { ref } from "vue";
import { useVendor } from "@/composables/vendor";
import Logo from "@/components/Logo.vue";
import { useUser } from "@/composables/user";
import { useAuth } from "@/composables/auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { currentVendor, isLoading, vendors } = useVendor();
const isVendorModalOpen = ref(false);
const { user, logout } = useAuth();

const navigation = [
  { name: "Dashboard", href: "/dashboard" },
  { name: "Orders", href: "/orders" },
];
const userNavigation = [{ name: "Sign out", href: "#" }];

const doLogout = async () => {
  await logout();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Disclosure), {
      as: "nav",
      class: "bg-white shadow-sm"
    }, {
      default: _withCtx(({ open }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Logo, { class: "block h-8 w-auto" }),
                _hoisted_5
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createVNode(_component_router_link, {
                    key: item.name,
                    to: item.href,
                    custom: ""
                  }, {
                    default: _withCtx(({ isActive, navigate }) => [
                      _createElementVNode("a", {
                        onClick: navigate,
                        href: item.href,
                        class: _normalizeClass([
                  isActive
                    ? 'border-indigo-500 text-gray-900'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium',
                ]),
                        "aria-current": isActive ? 'page' : undefined
                      }, _toDisplayString(item.name), 11, _hoisted_7)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_unref(vendors).length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "bg-white relative w-full rounded-md pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-gray-600",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isVendorModalOpen.value = true))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(currentVendor)?.shortname), 1),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_unref(SelectorIcon), {
                        class: "h-5 w-5 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(Menu), {
                as: "div",
                class: "ml-3 relative flex-shrink-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(MenuButton), { class: "bg-white flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        (_unref(user)?.picture)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "h-8 w-8 rounded-full",
                              src: _unref(user).picture,
                              alt: ""
                            }, null, 8, _hoisted_11))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_unref(UserIcon), { class: "w-5 h-5 text-gray-500" })
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-200",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuItems), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuItem), null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: doLogout,
                                href: "#",
                                class: _normalizeClass([
                      'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100',
                    ])
                              }, "Logout")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(DisclosureButton), { class: "bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  (!open)
                    ? (_openBlock(), _createBlock(_unref(MenuIcon), {
                        key: 0,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(_unref(XIcon), {
                        key: 1,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ]),
        _createVNode(_unref(DisclosurePanel), { class: "sm:hidden" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                return _createVNode(_unref(DisclosureButton), {
                  key: item.name,
                  as: "a",
                  href: item.href,
                  class: _normalizeClass([
            item.current
              ? 'bg-indigo-50 border-indigo-500 text-indigo-700'
              : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800',
            'block pl-3 pr-4 py-2 border-l-4 text-base font-medium',
          ]),
                  "aria-current": item.current ? 'page' : undefined
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["href", "class", "aria-current"])
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_unref(user)?.picture && false)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "h-10 w-10 rounded-full",
                        src: _unref(user).picture,
                        alt: ""
                      }, null, 8, _hoisted_19))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_unref(UserIcon), { class: "w-6 h-6 text-gray-500" })
                      ]))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(user).name), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(user).email), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                (_unref(vendors).length > 0)
                  ? (_openBlock(), _createBlock(_unref(DisclosureButton), {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (isVendorModalOpen.value = true)),
                      class: "block w-full px-4 py-2 text-base text-left font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(DisclosureButton), {
                  onClick: doLogout,
                  class: "block w-full px-4 py-2 text-base text-left font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(VendorModal, {
      open: isVendorModalOpen.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isVendorModalOpen).value = $event))
    }, null, 8, ["open"])
  ], 64))
}
}

})